import { render, staticRenderFns } from "./OnlyGameturbo.vue?vue&type=template&id=2c6de0c2"
import script from "./OnlyGameturbo.vue?vue&type=script&lang=js"
export * from "./OnlyGameturbo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports